"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransaction = void 0;
const wallet_btc_1 = require("./wallet-btc");
const errors_1 = require("@ledgerhq/errors");
const types_1 = require("./types");
const wallet_btc_2 = __importStar(require("./wallet-btc"));
const logs_1 = require("@ledgerhq/logs");
const selectUtxoPickingStrategy = (walletAccount, utxoStrategy) => {
    const handler = {
        [types_1.bitcoinPickingStrategy.MERGE_OUTPUTS]: wallet_btc_1.Merge,
        [types_1.bitcoinPickingStrategy.DEEP_OUTPUTS_FIRST]: wallet_btc_1.DeepFirst,
        [types_1.bitcoinPickingStrategy.OPTIMIZE_SIZE]: wallet_btc_1.CoinSelect,
    }[utxoStrategy.strategy];
    if (!handler)
        throw new Error("Unsupported Bitcoin UTXO picking strategy");
    return new handler(walletAccount.xpub.crypto, walletAccount.xpub.derivationMode, utxoStrategy.excludeUTXOs);
};
const buildTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const { feePerByte, recipient, opReturnData, utxoStrategy } = transaction;
    if (!feePerByte) {
        throw new errors_1.FeeNotLoaded();
    }
    const walletAccount = (0, wallet_btc_2.getWalletAccount)(account);
    const utxoPickingStrategy = selectUtxoPickingStrategy(walletAccount, transaction.utxoStrategy);
    const maxSpendable = yield wallet_btc_2.default.estimateAccountMaxSpendable(walletAccount, feePerByte.toNumber(), //!\ wallet-btc handles fees as JS number
    utxoStrategy.excludeUTXOs, [recipient], opReturnData);
    (0, logs_1.log)("btcwallet", "building transaction", transaction);
    const txInfo = yield wallet_btc_2.default.buildAccountTx({
        fromAccount: walletAccount,
        dest: transaction.recipient,
        amount: transaction.useAllAmount ? maxSpendable : transaction.amount,
        feePerByte: feePerByte.toNumber(),
        utxoPickingStrategy,
        // Definition of replaceable, per the standard: https://github.com/bitcoin/bips/blob/61ccc84930051e5b4a99926510d0db4a8475a4e6/bip-0125.mediawiki#summary
        sequence: transaction.rbf ? 0 : 0xffffffff,
        opReturnData,
    });
    (0, logs_1.log)("btcwallet", "txInfo", txInfo);
    return txInfo;
});
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map